import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5975e0c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-lists-item__wrapper" }
const _hoisted_2 = { class: "company-lists-item__content" }
const _hoisted_3 = { class: "company-lists-item__header" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-lists-item__smart-icon" }, null, -1))
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "company-lists-item__column-heading" }
const _hoisted_8 = { class: "company-lists-item__heading" }
const _hoisted_9 = { class: "company-lists-item__subtitle" }
const _hoisted_10 = {
  key: 0,
  class: "company-lists-item__column-heading company-lists-item__column-logos"
}
const _hoisted_11 = { class: "company-lists-item__heading" }
const _hoisted_12 = {
  key: 1,
  class: "company-lists-item__tip"
}
const _hoisted_13 = { class: "company-lists-item__actions" }
const _hoisted_14 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxAvatarGrid = _resolveComponent("PxAvatarGrid")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_PxAvatarSet = _resolveComponent("PxAvatarSet")!
  const _component_ListShare = _resolveComponent("ListShare")!
  const _component_ListOptions = _resolveComponent("ListOptions")!

  return (_openBlock(), _createElementBlock("div", {
    class: "company-lists-item",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.listClickHandler && _ctx.listClickHandler(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PxAvatarGrid, {
        items: _ctx.companyAvatars,
        size: 30,
        "visible-limit": 6,
        class: "company-lists-item__logo-grid"
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", {
            class: "company-lists-item__title",
            textContent: _toDisplayString(_ctx.value.title)
          }, null, 8, _hoisted_4),
          (_ctx.isSmarList)
            ? (_openBlock(), _createBlock(_component_ElTooltip, {
                key: 0,
                content: _ctx.smartListTooltipCopy,
                placement: "top",
                "popper-class": "company-lists-smart-item__tooltip el-abaca-tooltip"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["content"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", {
          class: "company-lists-item__description",
          textContent: _toDisplayString(_ctx.value.description)
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, [
          _createVNode(_component_PxIcon, {
            size: 15,
            name: "hashtag"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("companyLists.list.members")), 1)
        ]),
        _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$tc(
              `companyLists.list.membersCount[${_ctx.listUserType}]`,
              _ctx.value.companies.length,
            )), 1)
      ]),
      (_ctx.isOwner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h4", _hoisted_11, [
              _createVNode(_component_PxIcon, {
                size: 14,
                name: "arrow-share"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("companyLists.list.sharedWith")), 1)
            ]),
            (_ctx.userAvatars.length)
              ? (_openBlock(), _createBlock(_component_PxAvatarSet, {
                  key: 0,
                  items: _ctx.userAvatars,
                  size: 21,
                  "visible-limit": 5,
                  class: "company-lists-item__logo-set"
                }, null, 8, ["items"]))
              : (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                  _createVNode(_component_PxIcon, {
                    size: 16,
                    name: "lock"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("companyLists.list.sharedEmpty")), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.isOwner)
          ? (_openBlock(), _createBlock(_component_ListShare, {
              key: 0,
              value: _ctx.value,
              class: "company-lists-item__actions-item"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ListOptions, {
          value: _ctx.value,
          class: "company-lists-item__actions-item"
        }, null, 8, ["value"])
      ]),
      (_ctx.$screen.mdUp && _ctx.showPinToTop)
        ? (_openBlock(), _createBlock(_component_ElTooltip, {
            key: 1,
            ref: "pinTooltip",
            disabled: _ctx.listIsPinned,
            enterable: false,
            placement: "top",
            "popper-class": "company-lists-item__pin-tooltip el-abaca-tooltip"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", {
                textContent: _toDisplayString(_ctx.$t('companyLists.list.pinToTop'))
              }, null, 8, _hoisted_14)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'company-lists-item__pin-cta--active': _ctx.listIsPinned }, "company-lists-item__pin-cta"]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pinToTopClickHandler && _ctx.pinToTopClickHandler(...args)), ["stop"]))
              }, [
                _createVNode(_component_PxIcon, {
                  size: 16,
                  name: "pin"
                })
              ], 2)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}